import allWording from '@/wording'

/**
 * Mixin
 */
export default {
    created()
    {
        this.wording = allWording[this.$route.params.lang]
    }
}



// WEBPACK FOOTER //
// ./src/mixins/Wording.js